module.exports = __webpack_public_path__ + "static/media/not_single.ad855a81.png";